import AIOApis from "components/aio/aio-apis";
import { I_midmileTrip } from "./types";
import { mockData } from "./mock";

export class Apis extends AIOApis {
    constructor(p: { base_url: string, token: string }) {
        super({
            id: 'midmilemonitoring',
            handleErrorMessage: () => {
                return 'error'
            },
            mockServer:new Mockserver(),
            token: p.token,
            base_url: p.base_url,
            lang: 'fa'
        })
    }
    fetchTrips = async () => {
        const { success, response } = await this.request<{
            data: {
                "currentHub": {
                    id: number,
                    name: string,
                    latitude:number,longitude:number
                },
                items: I_midmileTrip[]
            }
        }>({
            name: 'fetchTrips',mock:undefined,
            method: 'get',
            url: '/consignment-api/trips/monitoring/trips'
        })
        if (success) {
            const currenthub = response.data.currentHub
            let vehicles:I_midmileTrip[] = response.data.items
            vehicles = vehicles.map((o)=>{
                return {
                    ...o,
                    nextStatus:o.nextStatus === null?undefined:o.nextStatus
                }
            })
            return {currenthub,vehicles}
        }
        else { debugger; return false }
    }
}


class Mockserver{
    fetchTrips = ()=>{
        return {data:mockData}
    }
}